import React from "react";
import { deleteParc, setEnableParc } from "../actions/parc";
import { connect } from "react-redux";
import { tempAlWait } from "../helpers";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical, faEye, faEyeSlash, faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";

class AdminItemParc extends React.Component {
    state = {
        optActive: false,
        parc: null,
        tempEnable: false
    }

    componentDidMount() {
        this.setState({
            parc: this.props.data
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.redDelParc != prevProps.redDelParc) {
            this.props.changeAlert(this.props.redDelParc.alert);

            if (this.props.redDelParc.isNext) {
                this.props.refreshList(true);
            }
        }

        if (this.props.redParcEnable != prevProps.redParcEnable && this.state.tempEnable) {
            this.props.changeAlert(this.props.redParcEnable.alert);

            if (this.props.redParcEnable.isNext) {
                let tempParc = this.state.parc;
                tempParc.isActive = !tempParc.isActive;
                this.setState({
                    parc: tempParc,
                    tempEnable: false
                })
            } else {
                this.setState({
                    tempEnable: false
                })
            }
        }
    }

    handleDelete(id) {
        if (window.confirm("Souhaitez-vous réellement supprimer ce parc ?")) {
            this.props.changeAlert(tempAlWait());
            this.props.deleteParc({id: id});
        }
    }

    handleEnable(el) {
        el.preventDefault();

        this.props.setEnableParc({
            parcId: this.state.parc?.id,
            isActive: !this.state.parc?.isActive,
        });
        this.props.changeAlert(tempAlWait());
        this.setState({
            tempEnable: true
        })
    }

    render() {
        return <li className={`admin__item admin__item--parc`}>
            {/** Id **/}
            <span className="admin__item__id">{this.state.parc?.parcId}</span>

            {/** Nom **/}
            <span className="admin__item__text">{this.state.parc?.name}</span>

            {/** Est actif **/}
            <button
                className="admin__item__eyebtn"
                onClick={(el) => this.handleEnable(el)}
                title={this.state.parc?.isActive ? "L'attraction est activée dans les temps d'attente" : "L'attraction n'est pas activée dans les temps d'attente"}
                aria-label={this.state.parc?.isActive ? "L'attraction est activée dans les temps d'attente" : "L'attraction n'est pas activée dans les temps d'attente"}
            >
                {this.state.parc?.isActive ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
            </button>

            {/** Options **/}
            <div className={`admin__item__opts ${this.state.optActive && "admin__item__opts--active"}`}>
                {/** Voir **/}
                <Link
                    title="Voir les attractions du parc"
                    aria-label="Voir les attractions du parc"
                    className="admin__item__optbtn"
                    to={`/admin/parc/attractions/${this.state.parc?.id}`}
                >
                    <FontAwesomeIcon icon={faEye} />
                </Link>
                {/** Modifier **/}
                <Link
                    title="Modifier le parc"
                    aria-label="Modifier le parc"
                    className="admin__item__optbtn"
                    to={`/admin/parc/edit/${this.state.parc?.id}`}
                >
                    <FontAwesomeIcon icon={faPen} />
                </Link>

                {/** Supprimer **/}
                <button
                    title="Supprimer le parc"
                    aria-label="Supprimer le parc"
                    className="admin__item__optbtn admin__item__optbtn--del"
                    onClick={() => this.handleDelete(this.state.parc?.id)}
                >
                    <FontAwesomeIcon icon={faTrashCan} />
                </button>
            </div>

            {/** Options bouton **/}
            <button
                title={this.state.optActive ? "Fermer les options" : "Ouvrir les options"}
                aria-label={this.state.optActive ? "Fermer les options" : "Ouvrir les options"}
                className="admin__item__btnopt"
                onClick={() => this.setState({optActive: !this.state.optActive})}
            >
                <FontAwesomeIcon icon={faEllipsisVertical} />
            </button>
        </li>
    }
}

const mapStateToProps = state => {
    return {
        redDelParc: state.redDelParc,
        redParcEnable: state.redParcEnable
    }
}

const mapDispatchToProps = {
    deleteParc,
    setEnableParc
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminItemParc);